<!-- 经营信息 -->
<template>
  <div class="business-info-view">
    <el-form
      :model="queryParams"
      :rules="rulesCompanyInfo"
      ref="BusinessInfoForm"
    >
      <p class="info-title">联系信息与公开信息</p>

      <div class="business-info-block">
        <el-form-item label="企业官网：" label-width="190px">
          <el-input
            v-model="queryParams.website"
            style="width: 470px"
            placeholder="请输入官网"
          />
        </el-form-item>

        <el-form-item label="企业电话：" label-width="190px">
          <el-input
            v-model="queryParams.telephone"
            style="width: 470px"
            placeholder="请输入企业电话"
          />
        </el-form-item>

        <el-form-item label="企业邮箱：" label-width="190px">
          <el-input
            v-model="queryParams.email"
            style="width: 470px"
            placeholder="请输入企业邮箱"
          />
        </el-form-item>

        <el-form-item label="微信公众号：" label-width="190px">
          <el-input
            v-model="queryParams.weChatOfficialAccount"
            style="width: 470px"
            placeholder="请输入微信公众号"
          />
        </el-form-item>

        <el-form-item label="企业微博：" label-width="190px">
          <el-input
            v-model="queryParams.enterpriseWeibo"
            style="width: 470px"
            placeholder="请输入企业微博"
          />
        </el-form-item>

        <el-form-item label="领英网址：" label-width="190px">
          <el-input
            v-model="queryParams.linkedInWebsite"
            style="width: 470px"
            placeholder="请输入领英网址"
          />
        </el-form-item>
      </div>

      <p class="info-title">企业规模</p>

      <div class="business-info-block">
        <el-form-item label="当前社保人数：" label-width="190px">
          <el-input
            v-model="queryParams.socialSecurityNumber"
            style="width: 470px"
            placeholder="请输入社保人数"
          />
        </el-form-item>

        <el-form-item label="过去第一年社保人数：" label-width="190px">
          <el-input
            v-model="queryParams.lastYearSbrs"
            style="width: 470px"
            placeholder="请输入社保人数"
          />
        </el-form-item>

        <el-form-item label="过去第二年社保人数：" label-width="190px">
          <el-input
            v-model="queryParams.qnSbrs"
            style="width: 470px"
            placeholder="请输入社保人数"
          />
        </el-form-item>

        <el-form-item label="企业规模：" label-width="190px">
          <!-- <SelectTreeRadio
            apiName="getDicRadioButton"
            :params="{ code: '047' }"
            resultType="ids"
            vFeild="codeId"
            lFeild="codeName"
            storageKey="enterpriseScale"
            :isCheckBoxButton="false"
            :isTree="false"
            v-model="queryParams.enterpriseScale"
          ></SelectTreeRadio> -->

          <el-radio-group v-model="queryParams.enterpriseScale">
            <el-radio
              v-for="(item, index) in query.enterpriseSize"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item label="纳税人类型：" label-width="190px">
          <el-input
            v-model="queryParams.taxpayerType"
            style="width: 470px"
            placeholder="请输入"
          />
        </el-form-item>

        <el-form-item label="过去第一年营收范围：" label-width="190px">
          <el-input
            v-model="queryParams.lastYearYsfw"
            style="width: 470px"
            placeholder="请输入"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item label="过去第二年营收范围：" label-width="190px">
          <el-input
            v-model="queryParams.qnYsfw"
            style="width: 470px"
            placeholder="请输入"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item label="过去第三年营收范围：" label-width="190px">
          <el-input
            v-model="queryParams.dqnYsfw"
            style="width: 470px"
            placeholder="请输入"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item label="过去第一年税收：" label-width="190px">
          <el-input
            v-model="queryParams.lastYearTax"
            style="width: 470px"
            placeholder="请输入"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item label="过去第二年税收：" label-width="190px">
          <el-input
            v-model="queryParams.qnTax"
            style="width: 470px"
            placeholder="请输入"
          />

          <span class="tag">万</span>
        </el-form-item>

        <el-form-item label="过去第三年税收：" label-width="190px">
          <el-input
            v-model="queryParams.dqnTax"
            style="width: 470px"
            placeholder="请输入"
          />

          <span class="tag">万</span>
        </el-form-item>
      </div>

      <p class="info-title">企业梯度与荣誉</p>

      <div class="business-info-block">
        <el-form-item label="是否为规上企业：" label-width="190px">
          <el-radio-group v-model="queryParams.isRegulatedEnterprises">
            <el-radio
              v-for="(item, index) in query.regulatedEnterprisesp"
              :key="index"
              :label="item.label"
            ></el-radio>
          </el-radio-group>
        </el-form-item>

        <div
          class="business-info-child"
          v-if="queryParams.isRegulatedEnterprises === '规上企业'"
        >
          <el-form-item label="认定年份：" label-width="90px" style="margin: 0">
            <DataTime
              @dateChange="dateClick"
              :isShowMonth="false"
              :parentYear="queryParams.regulatedYear"
            ></DataTime>
          </el-form-item>
        </div>

        <el-form-item label="是否为创新行中小企业：" label-width="190px">
          <!-- <div class="input-radio-box">
            <el-input
              style="width: 180px;"
              v-model="queryParams.gjgxjsEnterprises"
            ></el-input>
          </div> -->

          <el-radio-group v-model="queryParams.isCxxMinCompany">
            <el-radio label="是"></el-radio>

            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>

        <div
          class="business-info-child long-info"
          v-if="
            queryParams.isCxxMinCompany && queryParams.isCxxMinCompany !== '否'
          "
        >
          <el-form-item label="认定年份：" label-width="90px" style="margin: 0">
            <DataTime
              @dateChange="(e) => (queryParams.cxxMinCompanyYear = e)"
              :isShowMonth="false"
              :parentYear="queryParams.cxxMinCompanyYear"
            ></DataTime>
          </el-form-item>

          <el-form-item label="级别：" label-width="90px" style="margin: 0">
            <el-radio-group v-model="queryParams.cxxMinCompanyLevel">
              <el-radio label="国家级"></el-radio>
              <el-radio label="省级"></el-radio>
              <el-radio label="市级"></el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="是否为专精特新企业：" label-width="190px">
          <!-- <div class="input-radio-box">
            <el-input
              style="width: 180px;"
              v-model="queryParams.gjgxjsEnterprises"
            ></el-input>
          </div> -->

          <el-radio-group v-model="queryParams.zjtxEnterprisesType">
            <el-radio label="是"></el-radio>

            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>

        <div
          class="business-info-child long-info"
          v-if="queryParams.zjtxEnterprisesType && queryParams.zjtxEnterprisesType == '是'"
        >
          <el-form-item label="认定年份：" label-width="90px" style="margin: 0">
            <DataTime
              @dateChange="(e) => (queryParams.companyLevelYear = e)"
              :isShowMonth="false"
              :parentYear="queryParams.companyLevelYear"
            ></DataTime>
          </el-form-item>

          <el-form-item label="级别：" label-width="90px" style="margin: 0">
            <el-radio-group v-model="queryParams.levelCountry">
              <el-radio label="国家级"></el-radio>
              <el-radio label="省级"></el-radio>
              <el-radio label="市级"></el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <el-form-item label="是否为国家级小巨人：" label-width="190px">
          <!-- <div class="input-radio-box">
            <el-input
              style="width: 180px;"
              v-model="queryParams.gjgxjsEnterprises"
            ></el-input>
          </div> -->

          <el-radio-group v-model="queryParams.isLittleGiant">
            <el-radio label="是"></el-radio>

            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>

        <div
          class="business-info-child long-info"
          v-if="queryParams.isLittleGiant && queryParams.isLittleGiant !== '否'"
        >
          <el-form-item label="认定年份：" label-width="90px" style="margin: 0">
            <DataTime
              @dateChange="(e) => (queryParams.littleGiantYear = e)"
              :isShowMonth="false"
              :parentYear="queryParams.littleGiantYear"
            ></DataTime>
          </el-form-item>

          <el-form-item label="级别：" label-width="90px" style="margin: 0">
            <el-radio-group v-model="queryParams.littleGiantLevel">
              <el-radio label="国家级"></el-radio>
              <el-radio label="省级"></el-radio>
              <el-radio label="市级"></el-radio>
            </el-radio-group>
          </el-form-item>
        </div>

        <el-form-item label="是否为国家高新技术企业：" label-width="190px">
          <!-- <div class="input-radio-box">
            <el-input
              style="width: 180px;"
              v-model="queryParams.gjgxjsEnterprises"
            ></el-input>
          </div> -->

          <el-radio-group v-model="queryParams.gjgxjsEnterprises">
            <el-radio label="是"></el-radio>

            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>

        <div
          class="business-info-child long-info"
          v-if="
            queryParams.gjgxjsEnterprises &&
            queryParams.gjgxjsEnterprises !== '否'
          "
        >
          <el-form-item label="认定年份：" label-width="90px" style="margin: 0">
            <DataTime
              @dateChange="(e) => (queryParams.techYear = e)"
              :isShowMonth="false"
              :parentYear="queryParams.techYear"
            ></DataTime>
          </el-form-item>

          <el-form-item label="级别：" label-width="90px" style="margin: 0">
            <EarthAreaSelect
              :country="queryParams.techCountry"
              :province="queryParams.techProvince"
              :city="queryParams.techCity"
              :showRegion="false"
              @searchCountry="(e) => (queryParams.techCountry = e)"
              @searchProvince="(e) => (queryParams.techProvince = e)"
              @searchCity="(e) => (queryParams.techCity = e)"
            >
            </EarthAreaSelect>
          </el-form-item>
        </div>

        <el-form-item label="企业荣誉：" label-width="190px">
          <div class="business-honor-tags">
            <el-tag
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >+ New Tag</el-button
            >
          </div>
        </el-form-item>
      </div>

      <p class="info-title">上市信息</p>

      <div class="business-info-block">
        <el-form-item
          label="是否为上市公司："
          label-width="190px"
          prop="isListedCompany"
        >
          <el-radio-group
            :value="
              !companyStockList || !companyStockList.length
                ? '非上市企业'
                : '上市企业'
            "
          >
            <el-radio
              v-for="(item, index) in query.listedCompany"
              :key="index"
              :label="item.label"
            ></el-radio>
          </el-radio-group>
        </el-form-item>

        <div v-for="(item, index) in companyStockList" :key="index">
          <el-form-item
            label="上市板块："
            label-width="190px"
            prop="listedSector"
          >
            <el-input
              style="width: 700px"
              placeholder="请输入上市板块"
              v-model="item.stockType"
              disabled
            />
          </el-form-item>

          <el-form-item
            label="上市代码："
            label-width="190px"
            prop="listedCode"
          >
            <el-input
              style="width: 700px"
              placeholder="请输入上市代码"
              v-model="item.bondNum"
              disabled
            />
          </el-form-item>

          <el-form-item
            label="上市时间："
            label-width="190px"
            prop="listedTime"
          >
            <el-date-picker
              v-model="item.listedDate"
              type="datetime"
              placeholder="选择日期时间"
              style="width: 700px"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </div>
      </div>

      <p class="info-title">异常信息</p>

      <div class="business-info-block">
        <el-form-item label="经营异常：" label-width="190px">
          <el-radio-group v-model="queryParams.abnormalOperation">
            <el-radio
              v-for="(item, index) in query.judgeArray"
              :key="index"
              :label="item.label"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item label="司法异常：" label-width="190px">
          <el-radio-group v-model="queryParams.judicialAnomalies">
            <el-radio
              v-for="(item, index) in query.judgeArray"
              :key="index"
              :label="item.label"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </div>

      <p class="info-title">母公司信息</p>

      <div class="business-info-block">
        <el-form-item label="是否有母公司：" label-width="190px">
          <el-input
            v-model="queryParams.isParentCompany"
            style="width: 470px"
          />
        </el-form-item>

        <el-form-item label="母公司编号：" label-width="190px">
          <el-input
            v-model="queryParams.parentCompanyId"
            style="width: 470px"
          />
        </el-form-item>
      </div>

      <p class="info-title">
        融资投资&nbsp;&nbsp;{{ queryParams.financingList.length }}
      </p>

      <div class="business-info-block">
        <el-form-item
          label="是否融资："
          label-width="190px"
          prop="isParentCompany"
        >
          <el-radio-group
            :value="
              !queryParams.financingList || !queryParams.financingList.length
                ? 0
                : 1
            "
          >
            <el-radio
              v-for="(item, index) in query.judgeArray"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <div class="table-box ly_table_light">
          <el-table
            :data="queryParams.financingList"
            border
            style="width: 1010px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column
              label="序号"
              prop="companyId"
              align="center"
              width="83"
            >
            </el-table-column>

            <el-table-column
              label="披露日期"
              prop="pubTime"
              align="center"
              width="120"
            >
              <template v-slot="{ row }">
                <span>
                  {{
                    row.pubTime
                      ? $dayjs(row.pubTime).format("YYYY-MM-DD HH:mm:ss")
                      : "-"
                  }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              label="事件日期"
              prop="date"
              align="center"
              width="120"
            >
              <template v-slot="{ row }">
                <span>
                  {{
                    row.date
                      ? $dayjs(row.date).format("YYYY-MM-DD HH:mm:ss")
                      : "-"
                  }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              label="交易金额"
              prop="money"
              align="center"
              width="120"
            >
            </el-table-column>

            <el-table-column
              label="融资轮次"
              prop="round"
              align="center"
              width="111"
            >
            </el-table-column>

            <el-table-column
              label="估值"
              prop="value"
              align="center"
              width="98"
            >
            </el-table-column>

            <el-table-column
              label="比例"
              prop="share"
              align="center"
              width="98"
            >
            </el-table-column>

            <el-table-column
              label="投资方"
              prop="investorName"
              align="center"
              width="130"
            >
            </el-table-column>

            <el-table-column label="新闻来源" prop="newsUrl" align="center">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <p class="info-title">
        知识产权&nbsp;&nbsp;{{ queryParams.propertyRightsList.length }}
      </p>

      <div class="business-info-block">
        <div class="table-box ly_table_light">
          <p class="table-title">专利数据</p>

          <el-table
            :data="queryParams.propertyRightsList"
            border
            style="width: 1010px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column
              label="专利编号"
              prop="id"
              align="center"
              width="196"
            >
            </el-table-column>

            <el-table-column
              label="专利名称"
              prop="patentName"
              align="center"
              width="145"
            >
            </el-table-column>

            <el-table-column
              label="发明人"
              prop="inventor"
              align="center"
              width="178"
            >
            </el-table-column>

            <el-table-column
              label="专利类型"
              prop="patentType"
              align="center"
              width="242"
            >
            </el-table-column>

            <el-table-column
              label="专利状态"
              prop="patentStatus"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>

        <div class="table-box ly_table_light">
          <p class="table-title">软著数据</p>

          <el-table
            :data="queryParams.softwareRightsList"
            border
            style="width: 1010px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column
              label="软著编号"
              prop="id"
              align="center"
              width="196"
            >
            </el-table-column>

            <el-table-column
              label="软著名称"
              prop="softwareFullName"
              align="center"
              width="145"
            >
            </el-table-column>

            <el-table-column
              label="发明人"
              prop="author"
              align="center"
              width="178"
            >
            </el-table-column>

            <el-table-column
              label="软著类型"
              prop="softwareState"
              align="center"
              width="242"
            >
            </el-table-column>

            <el-table-column
              label="软著状态"
              prop="softwareType"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
// api
import { getBusinessInfo, updateBusinessInfo } from "@/api/customCompany.js";
// components
import SelectTreeRadio from "@/components/SelectTreeRadio.vue";
import DataTime from "@/components/DataTime.vue";
import EarthAreaSelect from "@/components/EarthAreaSelect/index.vue";

export default {
  components: {
    SelectTreeRadio,
    DataTime,
    EarthAreaSelect,
  },
  props: {
    enterpriseInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      rulesCompanyInfo: {
        companyFullName: [
          { required: true, message: "请输入公司全称", trigger: "blur" },
        ],
      },
      queryParams: {
        abnormalOperation: "", // 经营异常
        dqnTax: "", // 过去第三年税收
        dqnYsfw: "", // 过去第三年营收范围
        email: "", // 企业邮箱
        enterpriseHonor: "", // 企业荣誉
        enterpriseScale: "", // 企业规模
        enterpriseWeibo: "", // 企业微博
        financingList: [], // 融资信息列表
        gjgxjsEnterprises: "", // 是否为国家高新技术企业
        isListedCompany: "", // 是否为上市公司
        isParentCompany: "", // 是否为母公司
        isRegulatedEnterprises: "", // 是否为规上企业
        judicialAnomalies: "", // 司法异常
        lastYearSbrs: "", // 过去第一年社保人数
        lastYearTax: "", // 过去第一年税收
        lastYearYsfw: "", // 过去第一年营收范围
        linkedInWebsite: "", // 领英网址
        listedCode: "", // 上市代码
        listedSector: "", // 上市板块
        listedTime: "", // 上市时间
        parentCompanyId: "", // 母公司编号
        parentCompanyName: "", // 母公司名称
        propertyRightsList: [], // 专利数据列表
        qnSbrs: "", // 过去第二年社保人数
        qnTax: "", // 过去第二年税收
        qnYsfw: "", // 过去第二年营收范围
        socialSecurityNumber: "", // 当前社保人数
        softwareRightsList: [], // 软著数据列表
        taxpayerType: "", // 纳税人类型
        telephone: "", // 企业电话
        weChatOfficialAccount: "", // 微信公众号
        website: "", // 企业官网

        regulatedYear: "", // 规上企业认证年份
        companyLevelYear: "", // 专精特新认证年份
        levelCountry: "", // 专精特新国家
        levelProvince: "", // 专精特新省份
        levelCity: "", // 专精特新市区
        techYear: "", // 高新技术认证年份
        techCountry: "", // 高新技术国家
        techProvince: "", // 高新技术省份
        techCity: "", // 高新技术市区
        zjtxEnterprisesType: "",
        companyLevelYear: "",
        levelCountry: "",
        isCxxMinCompany: "",
        cxxMinCompanyYear: "",
        cxxMinCompanyLevel: "",
        isLittleGiant: "",
        littleGiantYear: "",
        littleGiantLevel: "",
      },
      query: {
        judgeArray: [
          { label: "是", value: 1 },
          { label: "否", value: 0 },
        ],
        // 企业规模
        enterpriseSize: [
          { label: "L（大型）", value: 4 },
          { label: "M（中型）", value: 3 },
          { label: "S（小型）", value: 2 },
          { label: "XS（微型）", value: 1 },
        ],
        // 规上企业
        regulatedEnterprisesp: [
          { label: "规下企业", value: 0 },
          { label: "规上企业", value: 1 },
        ],
        // 专精特新企业梯度
        enterpriseGradient: [
          { label: "无此梯度", value: 0 },
          { label: "创新型中小企业", value: 1 },
          { label: "市级专精特新", value: 2 },
          { label: "省级专精特新", value: 3 },
          { label: "国家级小巨人", value: 4 },
        ],
        // 上市企业
        listedCompanies: [
          { label: "上市企业", value: 0 },
          { label: "非上市企业", value: 1 },
        ],
        listedCompany: [
          { label: "上市企业", value: "上市企业" },
          { label: "非上市企业", value: "非上市企业" },
        ],
      },
      // 企业荣誉tag
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      // 融资投资
      financingTable: [],
      tableData: [],
      isInit: false,
      companyStockList: [],
    };
  },
  methods: {
    dateClick(e) {
      this.queryParams.regulatedYear = e;
    },
    getInfo() {
      if (this.isInit) {
        return;
      }

      getBusinessInfo({ id: this.$route.query.id }).then((res) => {
        if (res.code == 200) {
          this.isInit = true;
          this.queryParams = res.data;
          console.log("🚀 ~ getBusinessInfo ~ this.queryParams:", this.queryParams)
          if (typeof res.data.enterpriseHonor === "string") {
            const tags = res.data.enterpriseHonor;
            this.dynamicTags = tags ? tags.split("^") : [];
          }

          this.companyStockList = res.data.companyStockList;
        }
      });
    },
    // 提交数据
    submit() {
      // this.$modal.loading("正在保存数据，请稍候...");

      let params = {
        ...this.queryParams,
      };

      if (Array.isArray(this.dynamicTags)) {
        params.enterpriseHonor = this.dynamicTags.join("^");
      }

      updateBusinessInfo(params)
        .then((res) => {
          if (res.code === 200) {
            // this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.$modal.closeLoading();
        });
    },
    // 企业荣誉tag events
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style scoped lang="less">
.business-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .business-info-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
      border-bottom: 0;
    }

    .table-box {
      margin-top: 10px;
      padding-left: 190px;
      padding-bottom: 10px;

      .table-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
        color: #333333;

        &::before {
          content: "";
          display: block;
          margin-right: 4px;
          width: 7px;
          height: 7px;
          background-color: #1e9fff;
          border-radius: 50%;
        }
      }
    }
  }

  .business-info-child {
    margin-left: 80px;
    margin-bottom: 20px;
    padding: 10px;
    width: 320px;
    background-color: #f5f6f7;

    &.long-info {
      display: flex;
      width: 1100px;
    }
  }

  .tag {
    margin-left: 8px;
  }

  .input-radio-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
  }

  .business-honor-tags {
    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
}
</style>
